window.preownedApp = window.preownedApp || {};

async function fetchPreOwnderProduct(type, price) {
  const url = `https://music-all-in-backend.fly.dev/api/pre-owned/${encodeURIComponent(type)}?price=${price}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Inventory API error: ${response.status} ${response.statusText}`);
  }
  return response.json();
}

window.preownedApp.fetchPreOwnedProducts = async function (type, price) {
  try {
    return await fetchPreOwnderProduct(type, price);
  } catch (e) {
    console.error(e);
  }
  return null;
};
